import React from "react";
import Input from "../controls/input/customInput/CustomInput";
import { calculateDurationNoWeekends, calculateEndDateNoWeekends, calculateStartDateNoWeekends } from "../../views/dashboard/utils/date";

const DateRangeWithDuration = ({
    isLoading,
    startDate,
    endDate,
    onStartDateChange,
    onEndDateChange,
    revisedEndDate = null,
    onRevisedEndDateChange = null,
    showRevisedEndDate = false,
    startDateError,
    endDateError,
    revisedEndDateError,
    isStartDateDisabled = false,
    disabled = false,
    icon,
    label = true
  }) => {
    const effectiveEndDate = showRevisedEndDate && revisedEndDate ? revisedEndDate : endDate;
  
    const duration = startDate && effectiveEndDate
      ? calculateDurationNoWeekends(startDate, effectiveEndDate)
      : 0;
  
    const handleDurationChange = (value) => {
      if(!value || value === '')
          return;
  
      let newDuration = parseInt(value) || 0;
  
      if (newDuration <= 0) {
        onStartDateChange('');
        onEndDateChange('');
        if (showRevisedEndDate && onRevisedEndDateChange) {
          onRevisedEndDateChange('');
        }
        return;
      }
  
      if (startDate) {
        const newEndDate = calculateEndDateNoWeekends(startDate, newDuration);
  
        if (showRevisedEndDate && revisedEndDate && onRevisedEndDateChange) {
          onRevisedEndDateChange(newEndDate);
        } else {
          onEndDateChange(newEndDate);
        }
      } else if (!isStartDateDisabled) {
        const targetDate = showRevisedEndDate && revisedEndDate ? revisedEndDate : endDate;
  
        if (targetDate) {
          const newStartDate = calculateStartDateNoWeekends(targetDate, newDuration);
          onStartDateChange(newStartDate);
        } else {
          const today = new Date().toISOString().split('T')[0];
          const newEndDate = calculateEndDateNoWeekends(today, newDuration);
          onStartDateChange(today);
          onEndDateChange(newEndDate);
        }
      }
    };
  
    const handleStartDateChangeInternal = (value) => {
      onStartDateChange(value);
  
      if (!value || value === '') {
        onEndDateChange('');
      }
    };
  
    const handleEndDateChangeInternal = (value) => {
      onEndDateChange(value);
    };
  
    const handleRevisedEndDateChangeInternal = (value) => {
      if (onRevisedEndDateChange) {
        onRevisedEndDateChange(value);
      }
    };
  
    return (
      <>
        <div className={showRevisedEndDate ? "col-12" : "col-8"}>
          <div className="row gx-3">
            <div className={showRevisedEndDate ? "col-3" : "col-5"}>
              <Input
                icon={icon}
                value={startDate}
                maxDate={effectiveEndDate}
                type="date"
                handleChange={handleStartDateChangeInternal}
                label={label ? "Start Date" : ""}
                errorMessage={startDateError}
                isDisabled={disabled || isStartDateDisabled}
                loading={isLoading}
              />
            </div>
            <div className={showRevisedEndDate ? "col-3" : "col-5"}>
              <Input
                icon={icon}
                value={endDate}
                minDate={startDate}
                type="date"
                handleChange={handleEndDateChangeInternal}
                label={label ? "End Date" : ""}
                errorMessage={endDateError}
                isDisabled={disabled}
                loading={isLoading}
              />
            </div>
            {showRevisedEndDate && (
              <div className="col-3">
                <Input
                  icon={icon}
                  value={revisedEndDate}
                  minDate={startDate}
                  type="date"
                  handleChange={handleRevisedEndDateChangeInternal}
                  label={label ? "Revised End Date" : ""}
                  errorMessage={revisedEndDateError}
                  loading={isLoading}
                  isDisabled={disabled}
                />
              </div>
            )}
            <div className={showRevisedEndDate ? "col-3" : "col-2"}>
              <Input
                value={duration > 0 ? duration : ''}
                type="number"
                handleChange={handleDurationChange}
                label={label ? `${showRevisedEndDate ? "Duration (days)" : "Duration (d)"}` : ""}
                placeholder={`${showRevisedEndDate ? "0 days" : "0 d"}`}
                isDisabled={disabled}
                loading={isLoading}
              />
            </div>
          </div>
        </div>
      </>
    );
  };
  
  export default DateRangeWithDuration;